import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_DETRAN_CNH } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, CancelarAgendamentoPsicologo } from './types';

// ACTIONS
import {
	cancelarAgendamentoPsicologoSuccess,
	cancelarAgendamentoPsicologoFailure,
} from './actions';

function* cancelarAgendamentoPsicologo(request: ReducerAction) {
	const { payload }: { payload: CancelarAgendamentoPsicologo } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_DETRAN_CNH,
		`divisao-equitativa/${CHANNEL}/cancelar-agendamento-psicologo`,
		payload,
	);

	if (response.status === 200) {
		yield put(cancelarAgendamentoPsicologoSuccess(response));
	} else {
		yield put(cancelarAgendamentoPsicologoFailure(response));
	}
}

export default all([
	takeLatest(
		Types.CANCELAR_AGENDAMENTO_PSICOLOGO_REQUEST,
		cancelarAgendamentoPsicologo,
	),
]);
